import { legacyPlugins } from "/app/node_modules/nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}